import { render, staticRenderFns } from "./AdminAnalysisDetail.vue?vue&type=template&id=291c71ee&scoped=true&"
import script from "./AdminAnalysisDetail.vue?vue&type=script&lang=js&"
export * from "./AdminAnalysisDetail.vue?vue&type=script&lang=js&"
import style0 from "./AdminAnalysisDetail.vue?vue&type=style&index=0&id=291c71ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291c71ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAlert,VBtn,VContainer,VDataTable,VIcon})
